import type { components } from "../../../../../../../types/api.types";
import { ADDITIONAL_ERROR_LABELS } from "../VollmachtVermarkterConfirmation.constants";

type ValidationError = components["schemas"]["ValidationErrorCodeMessage"];

function extractAdditionalErrorValues(message: string): string | undefined {
  const separatorIndex = message.lastIndexOf(":");
  if (separatorIndex === -1) {
    return undefined;
  }

  const values = message.slice(separatorIndex + 1).trim();
  return values.length > 0 ? values : undefined;
}

/**
 * Formats an additional validation error for display by translating known error
 * codes and preserving any values appended after the last colon in the backend
 * message.
 *
 * Example:
 * `formatAdditionalErrorMessage({ code: "unexpected_see_number_found", message: "Unexpected SEE-Nummern found in document: SEE123", is_reason_for_rejection: false })`
 * returns `"Unerwartete SEE-Nummer(n) gefunden: SEE123"`.
 *
 * @param error - Backend validation error payload.
 * @returns A translated, user-facing error message.
 */
export function formatAdditionalErrorMessage(error: ValidationError): string {
  const translatedLabel = ADDITIONAL_ERROR_LABELS[error.code];
  if (!translatedLabel) {
    return error.message;
  }

  const values = extractAdditionalErrorValues(error.message);
  return values ? `${translatedLabel}: ${values}` : translatedLabel;
}
